<template>
  <div>
    <div class="flex wrap">
      <div v-for="(item,index) in pics" :key="index" class="show-upload-list-item">
        <img :src="item" />
        <div class="show-action">
          <div class="flex space alcenter">
            <a-icon @click="showDiv(index)" type="eye" />
            <a-icon @click="delPic(index)" style="margin-left: 15px;" type="delete" />
          </div>
        </div>
      </div>
      <!--原有的不太好用-->
      <div v-if="value.length<num">
        <a-upload name="file" listType="picture-card" class="upload-list" :show-upload-list="false"
                  :customRequest="uploadImg" :beforeUpload="beforeUpload" >
          <div>
            <slot></slot>
          </div>
        </a-upload>
      </div>
    </div>

    <a-modal :title="null" v-model="showDivAlert" :footer="null" :closable="false" @cancel="showDivAlert=false">
      <img style="width: 100%;" :src="pics[selectIndex]" />
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {

    value: {
      type: Array,
      default: function() {
        return new Array;
      }
    },
    num:{
      type:Number,
      default:10,
    }
  },
  computed: {
    pics() {
      return this.value;
    }
  },
  created() {
    console.log(this.value);
  },
  data() {
    return {
      loading: false,
      showDivAlert: false,
      selectIndex: 0
    }
  },
  methods: {
    showDiv(index) {
      this.selectIndex = index;
      this.showDivAlert = true;
    },
    delPic(index) {

      this.$confirm({
        title: '确定要删除吗？',
        content: '删除该文件',
        okText: '确定',
        okType: 'danger',
        cancelText: this.$t('common.cancel'),
		okButtonProps: {
		    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
		  },
        onOk: () => {
          let pics = JSON.parse(JSON.stringify(this.value));
          pics.splice(index, 1);
          this.$emit('input', pics);
        },
        onCancel: () => {
          console.log('Cancel');
        },
      });
    },
    uploadImg(e) {
      let file = e.file;
      this.loading = true;
      this.$http.upload(file).then(res => {
        let value = JSON.parse(JSON.stringify(this.value));
        value.push(res.fullurl);
		let obj={
			name:e.file.name,
			file:res.fullurl
		}
        this.$emit('input', obj);
        this.loading = false;

      }).catch(res => {
        console.log(res)
        this.$message.error('上传文件出错了');
        this.loading = false;

      });
    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error('文件最大为20M')
      }
      if(this.value.length>=this.num){
        this.$message.error('你上传的文件已达到'+this.num+'份')
      }
      return isLt2M;
    },

    formatFloat(f, digit) {
      let m = Math.pow(10, digit);
      let num = Math.round(f * m) / m;
      return num;
    }

  },
}
</script>

<style>
.show-upload-list-item {
  padding: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s ease;
  transition: border-color 0.3s ease;
  overflow: hidden;
  width: 128px;
  height: 128px;
  position: relative;
}

.show-upload-list-item .show-action {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 24px;
}

.show-upload-list-item:hover .show-action {
  opacity: 1;
}

.show-upload-list-item:hover {
  border-color: #4772FF;
}

.show-upload-list-item img {
  object-fit: cover;
  width: 110px;
  height: 110px;
}
.upload-list > .ant-upload.ant-upload-select-picture-card {
 width: fit-content;
 height: auto;
 border: none;
 background-color: transparent;
}
.upload-list >.ant-upload.ant-upload-select-picture-card > .ant-upload{
	padding: 0;
}
.upload-list>.ant-upload {
/*  width: 128px;
  height: 128px; */
  overflow: hidden;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
